// Module
var code = "<label for=\"{{ id }}\"></label> <button id=\"{{ id }}\" ngf-select=\"upload($files)\" ngf-multiple=\"{{ multiple }}\" type=\"file\" ngf-model-options=\"{debounce: 100}\" ngf-accept=\"accept\" ngf-min-size=\"params.minSize\" ngf-max-size=\"params.maxSize\" ng-if=\"params.local\" style=\"opacity:0;position:absolute\"></button> ";
// Exports
export default code;